import { Flex } from 'antd';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import styles from './nav-mobile.module.scss';
import { Button } from '@/components/button/button';
import LogoIcon from '@/assets/icons/voice-logo.svg?react';
import Hamburger from '@/assets/icons/hamburger-menu.svg?react';
import Icon from '@ant-design/icons';

interface NavMobileProps {
  className?: string;
  toggleMenu: () => void;
}

export default function NavMobile({ className, toggleMenu }: NavMobileProps) {
  return (
    <Flex className={clsx(styles.container, className)}>
      <Link to="/">
        <Icon component={() => <LogoIcon data-testid="logo-icon" />} style={{ fontSize: '37px' }} />
      </Link>
      <Button
        className={styles.navButton}
        data-testid="nav-mobile-button"
        buttonVariant="tertiary"
        onClick={toggleMenu}
        icon={<Hamburger className={styles.icon} style={{ width: '30px', height: '30px' }} />}
      />
    </Flex>
  );
}
